module.exports = __webpack_public_path__ + "static/img/blue.aea63bd3.png";